import { Button } from "@elaniintc/goes-design-system";

interface DetailFooterProps {
  rowCount: number;
  selectedCount: number;
  canDeleteRegistry: boolean;
  isDeleteDisabled: boolean;
  onDelete: () => void;
}

export const DetailFooter = ({
  rowCount,
  selectedCount,
  canDeleteRegistry,
  isDeleteDisabled,
  onDelete,
}: DetailFooterProps) => {
  return (
    <div className="w-full flex justify-between items-center px-3 bg-neutral-object border-t border-neutral-quiet py-4">
      <p className="text-body text-sm font-normal">
        Mostrando{" "}
        <span className="text-body-loud font-semibold">{rowCount}</span> filas
      </p>
      {selectedCount > 0 && (
        <div className="flex items-center gap-2">
          <p className="text-body font-normal text-sm">
            <span className="text-body-loud font-semibold">
              {selectedCount}
            </span>{" "}
            registro(s) seleccionado(s)
          </p>
          {canDeleteRegistry && (
            <Button
              variant="danger-tertiary"
              size="xs"
              type="button"
              disabled={isDeleteDisabled}
              onClick={onDelete}
            >
              Eliminar
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailFooter;
